export class Product {
    public id: string;
    public groupId: string;
    public name: string;
    public price: number;
    public graphicUrl: string;
}